import { wallet as n } from "../store/index.mjs";
import { commonOwner as a } from "../util/common.mjs";
import { ERROR_CONNECT_WALLET as o } from "./errors.mjs";
import { useStakingPoolContract as e } from "../store/stakingPoolContract.mjs";
const c = a(e);
async function l(t) {
  return (await e().poolData(t)).totalStakeAmount;
}
function w(t) {
  const r = n?.getAddress();
  if (r === void 0) throw o;
  return e().getStakingAmountByPoolID(r, t);
}
function f(t) {
  const r = n?.getAddress();
  if (r === void 0) throw o;
  return e().getPendingReward(t, r);
}
function m() {
  return e().rewarder();
}
async function g(...t) {
  return await e(!0).setRewarder(...t);
}
async function R() {
  return await e().optionFactory();
}
async function y(...t) {
  return await e(!0).setFactory(...t);
}
function p(t, r) {
  return e(!0).stake(t, r);
}
function A(t, r) {
  return e(!0).unstake(t, r);
}
function k(t, r) {
  return e(!0).unstakeAndRedeemReward(t, r);
}
function P(t) {
  return e(!0).redeemRewards(t);
}
function I(t) {
  return e().poolInfos(t);
}
function D(t) {
  return e().poolData(t);
}
function h() {
  return e().lastPoolId();
}
async function S(...t) {
  return await e(!0).setIsActive(...t);
}
async function B(...t) {
  if (n?.getAddress() == null) throw o;
  return await e(!0).setPoolReward(...t);
}
async function E(t) {
  if (n?.getAddress() == null) throw o;
  return await e(!0).redeemRewardsByList(t);
}
async function F(...t) {
  if (n?.getAddress() == null) throw o;
  return await e(!0).createPool(...t);
}
async function v(...t) {
  if (n?.getAddress() == null) throw o;
  return await e(!0).extendEndBlock(...t);
}
export {
  F as createPool,
  v as extendEndBlock,
  f as getPendingReward,
  l as getPoolTotalStake,
  E as getRewardFromSniperPools,
  w as getStakingAmountByPoolID,
  h as lastPoolId,
  R as optionFactory,
  c as owner,
  D as poolData,
  I as poolInfos,
  P as redeemRewards,
  m as rewarder,
  y as setFactory,
  S as setIsActive,
  B as setPoolReward,
  g as setRewarder,
  p as stake,
  A as unstake,
  k as unstakeAndRedeemReward
};
//# sourceMappingURL=staking_pool.mjs.map
